import { createSlice } from "@reduxjs/toolkit";

const initialState = { 

    cafePauseDuration: 10, 
    cafePauseStartTime: null,
    cafePauseActive: false,
    userToUnfocus: null,
};

const coffePauseSlice = createSlice({
    name: "coffePause",
    initialState,
    reducers: {
        startPause: (state, action) => {
            state.cafePauseActive = true;
            const onlyTime = new Date().toTimeString().split(' ')[0];
            state.cafePauseStartTime =  onlyTime;
            state.userToUnfocus = action.payload;
        },
        
        // Arrêter la pause manuellement ou à la fin du timer
        stopPause: (state) => {
        
            state.cafePauseActive = false;
            state.cafePauseStartTime = null;
            state.userToUnfocus = null;
        },

  

        // Réinitialiser l'état
        resetPauseState: () => initialState
    }
});

// Export des actions pour les utiliser dans vos composants avec dispatch()
export const { 
    startPause, 
    stopPause, 
    setPauseDuration, 
    resetPauseState 
} = coffePauseSlice.actions;

// Export du reducer pour le store
export default coffePauseSlice.reducer;